export { IconBrandAndSymbol } from './IconBrandAndSymbol';
